
import { useEffect, useRef, useState } from "react"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from "notistack"
import { useSearchParams, useLocation, useNavigate } from "react-router-dom"
import CircleIcon from "@mui/icons-material/Circle";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import './refund-confirm-form.css'
import RejectModal from "../Modals/Reject-modal"
import AcceptModal from "../Modals/Accept-modal"

const RefundConfirmationForm = () => {

    const [searchParams, setSearchParams] = useSearchParams()
    const id = searchParams.get('id')
    const { enqueueSnackbar } = useSnackbar()
    const [itineraryDetail, setItineraryDetail] = useState()
    const [ibanDetail, setIbanDetail] = useState()
    const { state } = useLocation()
    const [linkDetail, setDetail] = useState(null)
    const [notice, setNotice] = useState('')
    const navigate = useNavigate()
    const rejectModalRef = useRef()
    const acceptModalRef = useRef()
    const openModal = () => rejectModalRef.current.openModal()
    const openAcceptModal = () => acceptModalRef.current.openModal()
    let iban = {}
    let itinerary = {}

    console.log(state, ' this is state')
    const getInquiryItinerary = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.inquiryItinerary(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if (!res) return

        itinerary = res.data
        setItineraryDetail(itinerary)

        const response = await ajax({
            method: 'GET',
            url: utils.urls.linkDetail(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if (!response) return

        setDetail(response.data)
    }

    const getInguiryIban = async () => {
        const res = await ajax({
            method: "GET",
            url: utils.urls.ibanInquiry(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if (!res) return

        iban = res.data

        setIbanDetail(iban)
    }

    const blockPayment = async()=>{
        const res = await ajax({
            method:"GET",
            url: utils.urls.transactionBlock(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!res) return
        navigate("/agent/payments")
    }

    const confirmIban = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.confirmIban(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!res) return

        navigate('/agent/payments')
    }

    const checkRepeatedTransaction = async () => {

        const queryParmas = `?reference=${state?.reference}&transactionStatuses=PAID&paymentTypes=REFUND_IBAN` 
        const response = await ajax({
            method: 'GET',
            url: utils.urls.paymentList + queryParmas,
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!response) return

        console.log(response, 'log log')
        if(response.data.content.length > 0){
            setNotice('This reference has PAID refund transaction! ')
        }else{
            return
        }
    }
    
    const status2class = (status)=>{
        return {
            80: 'info',
            39: 'success',
            16:'err',
            // USER_FAILED:'err',
            // SERVER_FAILED:'err',
            // BLOCKED: 'block'
        }[status]
    }

    useEffect(() => {
         getInguiryIban()
         getInquiryItinerary()
         checkRepeatedTransaction()
    }, [])
    return (
        <>  
            {
                notice !== '' &&
                <div className="notice">
                    <span className="notice-text">{notice}</span>
                </div>
            }
            <div style={{'display': 'flex', 'width': '100%', 'gap': '8px'}}>
                <div className="passenger-information-container" style={{ 'width': '40%', 'border': '1px solid #e0e0e0', 'borderRadius': '14px', 'fontFamily': 'sans-serif'}}>
                    <div style={{'height': '40px', 'background': '#1B1464', 'borderRadius': '14px 14px 0px 0px' , 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center'}}>
                        <span style={{'color': '#FFFFFF', 'fontSize': '16px', 'fontWeight': '700', 'fontFamily': 'sans-serif'}}>Passengers Information</span> 
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'gap': '12px', 'paddingLeft': '10px', 'marginBottom': '8px', 'marginTop': '8px', 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Account Owner</label>
                        <span >{ibanDetail?.accountOwner}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'gap': '12px', 'paddingLeft': '10px', 'marginBottom': '8px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Account Status</label>
                        {
                            ibanDetail?.accountStatus === 'ACTIVE' &&
                            <span style={{'color': 'green'}}>{ibanDetail?.accountStatus}</span>
                        }
                        {
                            ibanDetail?.accountStatus !== 'ACTIVE' &&
                            <span style={{'color': 'red'}}>{ibanDetail?.accountStatus}</span>
                        }
                    </div>
                    <div className="info-row" style={{'paddingLeft': '10px', 'marginBottom': '8px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label style={{display: 'block', marginBottom: 12}}>Refund Amount</label>
                        <span>{state?.amount.toLocaleString()}</span>
                        <span style={{'marginLeft': '10px', 'fontSize': '14px'}}>{state?.currency.code}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'paddingLeft': '10px', 'marginBottom': '8px', 'gap': '12px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Mobile</label>
                        <span>{state?.mobile}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'paddingLeft': '10px', 'marginBottom': '8px', 'gap': '12px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Product</label>
                        <span>{state?.product?.name}</span>
                    </div>
                    <div className="info-row"  style={{'display': 'flex', 'flexDirection': 'column', 'paddingLeft': '10px', 'marginBottom': '8px', 'gap': '12px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Reference</label>
                        {
                            itineraryDetail?.paymentBOS.length !== 0 && <span>{state?.reference}</span>
                        }
                        {
                            itineraryDetail?.paymentBOS.length === 0 && <span style={{'color': 'red'}}>{state?.reference} (Wrong Reference!)</span>

                        }
                        
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'paddingLeft': '10px', 'marginBottom': '8px', 'gap': '12px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Creator Office</label>
                        <span>{itineraryDetail?.paymentBOS[0]?.officeCode}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'paddingLeft': '10px', 'marginBottom': '8px', 'gap': '12px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Refunder Office / User</label>
                        <span>{state?.createdBy?.office?.code} / {state?.createdBy?.username}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'paddingLeft': '10px', 'marginBottom': '8px', 'gap': '12px' , 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Homares Refund Date</label>
                        <span>{state?.additionalDate}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'gap': '12px', 'paddingLeft': '10px', 'marginBottom': '8px', 'marginTop': '8px', 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >User's Comment</label>
                        <span>{linkDetail?.comments}</span>
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'gap': '12px', 'paddingLeft': '10px', 'marginBottom': '8px', 'marginTop': '8px', 'paddingBottom': '5px' , 'borderBottom': '1px solid #e0e0e0'}}>
                        <label >Payments</label>
                        {
                            itineraryDetail?.paymentBOS.map((item , index) => {

                                const paymentStyle = {
                                    color: JSON.stringify(item.paidAmount).startsWith('-') ? 'red' : '#000000',
                                    marginTop: '40px'
                                }
                                return <div style={{"width": '100%', }}>
                                    <span >{index+1}/  </span>
                                    <span style={paymentStyle}>   {'  ' + item.paidAmount.toLocaleString() + '   ' + item.paidCurrency}</span>
                                </div> 
                            })
                        }
                    </div>
                    <div className="info-row" style={{'display': 'flex', 'flexDirection': 'column', 'gap': '12px', 'paddingLeft': '10px', 'marginBottom': '8px', 'marginTop': '8px', 'paddingBottom': '5px'  }}>
                        <label >Passengers</label>
                        {
                            itineraryDetail?.passengersBO?.passengerBOList.map((item, index) => {
                                return <div style={{"width": '100%', 'overflow': 'hidden'}}>
                                    <span >{index+1}-  </span>
                                    <span >   {'  ' + item.givenName+ '   ' + item.surName}</span>
                                    <span style={{'marginLeft': '5px' ,'fontSize': '12px'}}>({item.passengerTypeCode})</span>
                                    <div style={{ 'marginTop': '2px'}}>
                                        <span >Ticket NO:  {item.ticketNumber}</span>
                                    </div>
                                </div> 
                            })
                        }
                    </div>
                    {/* <div style={{"width": '100%', 'marginTop': '10px', 'borderTop': '1px solid #c9c8d5', 'fontFamily': 'sans-serif' }}>
                        <div style={{'display': 'block', 'marginBottom': '10px','fontSize': '14px', 'color': 'rgb(0 184 210)', 'marginTop': '10px', 'marginLeft': '10px'}}>Passengers</div>
                        {
                            itineraryDetail?.passengersBO?.passengerBOList.map((item, index) => {
                                return <div style={{"width": '100%', 'marginTop': '15px', 'marginBottom': '8px', 'overflow': 'hidden'}}>
                                    <span style={{'marginLeft': '10px'}}>{index+1}-  </span>
                                    <span style={{'marginTop': '40px'}}>   {'  ' + item.givenName+ '   ' + item.surName}</span>
                                    <span style={{'marginLeft': '5px' ,'fontSize': '12px'}}>({item.passengerTypeCode})</span>
                                    <div style={{'paddingLeft': '10px', 'marginTop': '2px'}}>
                                        <span style={{'fontSize': '14px'}}>Ticket NO:  {item.ticketNumber}</span>
                                    </div>
                                </div> 
                            })
                        }
                    </div> */}
                </div>
                <div style={{'width': '60%', 'border': '1px solid #e0e0e0', 'borderRadius': '14px', 'fontFamily': 'sans-serif', 'height': 'fit-content'}}>
                    <div style={{'height': '40px', 'background': '#1B1464', 'borderRadius': '14px 14px 0px 0px', 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center'}}>
                        <span style={{'color': '#FFFFFF', 'fontSize': '16px', 'fontWeight': '700', 'fontFamily': 'sans-serif'}}>Flights</span>        
                    </div>

                    {
                        itineraryDetail?.flightBOS.map( (item , index) => {
                            const singleStyle = {
                                backgroundColor: item.status === '16' ? '#dfdfdd' : 'transparent', // Change 'red' to any color you prefer
                                width: '100%',
                                direction: 'ltr'
                            };
                            // const borderStyle = {
                            //     border: '1px solid',
                            //     borderRadius: '14px',
                            //     minWidth: '52px',
                            //     paddingRight: '3px',
                            //     backgroundColor: item.status === '16' ? '#ffd2a2': '#bcefb2',
                            //     borderColor: item.status === '16' ? '#ffd2a2': '#bcefb2',
                            //     color: item.status === '16' ? '#874702': '#1d6302',
                            //     fontSize: '12px'
                            // }
                            return <div style={{"width": '100%'}}> 
                                <div className="single" style={singleStyle}>
                                    <div className="logo" style={{'display': 'flex', 'flexDirection': 'column', 'alignItems': 'center'}}>
                                        <p>Flight NO</p>
                                        <p>{`${item.flightNumber}`}</p>
                                        <p className={`status status-${status2class(item.status)}`} >{(item.status === '16' ? 'Canceled': item.status === '39' ? 'Confirmed' : 'Flown')}</p>
                                    </div>
                                    <div className="flight">
                                        <div className="departure">
                                        <p className="text1">
                                            {utils.getTime(item.departureDateTime)}
                                        </p>
                                        <p className="text2">
                                            {item.departureAirport.airportName}
                                        </p>
                                        <p className="text3">
                                            
                                            {item.departureAirport.airportCode}
                                        </p>
                                        </div>
                                        <div className="detail-flight">
                                        {/* <div className="detail-flight__row" style={{'transform': 'rotate(135deg)'}}>
                                            <AirplanemodeActiveIcon />
                                        </div> */}
                                        <div className="divider" style={{}}>
                                            <p>{item.departureDateTime.split('T')[0]} </p>
                                            <p style={{position:'relative'}}>
                                              <AirplanemodeActiveIcon style={{position:'absolute', top: -10, left:-23, transform: "rotate(90deg)"}}/>
                                              <CircleIcon fontSize="14px" style={{position:'absolute', top: -6, right: -13}}/>
                                            </p>
                                            <p>{utils.getAlphabetDate(item.departureDateTime, 'en', 'ddd jD jMMMM')} </p>
                                            {/* <p className="mobile-flightNo">{`شماره پرواز: ${item.flightNumber}`}</p> */}
                                        </div>
                                        {/* <div>
                                            <CircleIcon fontSize="13px"/>
                                        </div> */}
                                        </div>

                                        <div className="departure">
                                        
                                        <p className="text1">{utils.getTime(item.arrivalDateTime)}</p>
                                        <p className="text2">
                                            
                                            {" "}
                                            {item.arrivalAirport.airportName}
                                        </p>
                                        <p className="text3">
                                            
                                            {item.arrivalAirport.airportCode}
                                        </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>

            <div className="btn-container">
                <button className="back-list" onClick={() => navigate('/agent/payments')}>Back</button>
                <button className="payment-btn-back" onClick={() => openModal()}>Reject</button>
                <button className="payment-btn" onClick={() => openAcceptModal()}>Approve</button>
            </div>  
            <RejectModal ref={rejectModalRef}/>
            <AcceptModal ref={acceptModalRef} />
        </>
    )

}

export default RefundConfirmationForm